import URLConfig from '@Config/urls/url.config';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { Link, Outlet } from 'react-router-dom';

export default function Devise() {
  const tablinkStyle = { borderBottom: '2px solid lightblue', padding: '5px' }
  return (
    <>
      <CC.Box>
        <CC.Stack direction="row" spacing={2}>
            <Link
              style={tablinkStyle}
              to={URLConfig.ADMIN.BASE_SETTINGS.BANK.DEVISE.DIVISE_DEFINITION}
            >
              Définition des devises
            </Link>
            <Link
              style={tablinkStyle}
              to={
                URLConfig.ADMIN.BASE_SETTINGS.BANK.DEVISE.UPDATE_CONVERSION_TAUX
              }
            >
              MAJ du taux de conversion
            </Link>
            <Link
              style={tablinkStyle}
              to={
                URLConfig.ADMIN.BASE_SETTINGS.BANK.DEVISE
                  .CONVERSION_TAUX_CONSULTATION
              }
            >
              Consultation du taux de conversion
            </Link>
        </CC.Stack>

        <CC.Box pt="10">
          <Outlet />
        </CC.Box>
      </CC.Box>
    </>
  );
}
